import { Recipient } from '../form'
import { Excel } from './excel'
import Page, { BlocksHtml, BlocksPipes, Galleries } from './page'
import { PDF } from './pdf'
import { RequestApi } from './request'

export default interface Report {
    title: string
    uid: string | undefined
    description?: string
    isDraft: boolean
    enabled: boolean
    listen?: string
    mailSettings: MailSettings
    testRecipients: string[]
    mailContent: MailContent
    page: Page
    files: {
        excel: Excel[]
        pdf?:PDF[]
    }
    createdAt?: number
    updatedAt?: number
    lastExecutedAt?: number
    createdBy?: {
        id: number
        name: string
        username: string
    }
}
export interface DeletedReport extends RequestApi {
    deleted: true
}
export interface newReport extends RequestApi {
    config: Report
}
export interface PublishedReport {
    success: boolean
    error: string
}

export interface DuplicateReport extends RequestApi {
    jsonConfig?: string
    success: boolean
    error: string
}

export interface MailSettings {
    subject: string
    useCredits: boolean
    errorRecipients: string[]
    recipients?: Recipient[]
    channels: string[]
    mailSettingsInstances?: MailSettingsInstance[]
}

export interface MailSettingsInstance {
    name: string
    cron: string
    isRecurrent: boolean
    isRuleAlarm?: boolean
    recipientsUid: string[]
    uuid?: string
    active: boolean
    span?: string
    ruleId?:string
    throttleAlarm?: number
    throttleAlarmUomFormat?: string
}

export interface FGeneralSettings {
    title: string
    enabled: boolean
    description: string
}

export interface MailContent {
    blockLayout: string
    layout: ReportLayout[]
    generalSpan: string
}

export enum WidgetTypes {
    PIPES = 'pipes',
    HTML = 'html',
    GALLERY = 'gallery'
}

export const widgetTypeToUserText = (type: WidgetTypes) => {
    switch(type) {
        case WidgetTypes.GALLERY:
            return "Gallery";
        case WidgetTypes.HTML:
            return "Text";
        case WidgetTypes.PIPES:
            return "Html/Pipes";
        default:
            return "";
    }
}

export enum SectionTypes {
    PIPES = 'pipes',
    GALLERY = 'gallery'
}

export interface ReportLayout {
    type: WidgetTypes
    id: number
}

export type PropsToWrapper = BlocksPipes | BlocksHtml | Galleries

const defaultReport = {
    title: 'new report',
    isDraft: true,
    enabled: false
} as Report

export { defaultReport }
